<template>
  <div>
    <b-modal 
      id="form-employee-paid-leave-modal" 
      size="lg" 
      no-close-on-backdrop
      :title="(editId == null ? 'Tambah' : 'Edit') + ' ' + pageTitle" >
      <validation-observer ref="employeePaidLeaveValidation">
        <form>
          
          <horizontal-form-group label="Cabang">
            <validation-provider #default="{ errors }" name="branchId">
              <BranchListComponent :value="branchId" @value="branchId = $event"/>
            </validation-provider>
          </horizontal-form-group>

          <horizontal-form-group label="Karyawan">
            <validation-provider #default="{ errors }" name="employeeId">
              <EmployeeListComponent :value="formPayload.employeeId" @value="formPayload.employeeId = $event" :isLoadingEmployeeList="isLoadingEmployeeList" filterBy="branch" :filterValue="filterValue"/>
            </validation-provider>
          </horizontal-form-group>

          <horizontal-form-group label="Kuota">
            <validation-provider #default="{ errors }" name="paidLeaveLeft" rules="required">
              <InputText :value="formPayload.paidLeaveLeft" @value="formPayload.paidLeaveLeft = $event" :errors="errors" />
            </validation-provider>
          </horizontal-form-group>
          
          
        </form>
      </validation-observer>

      <template #modal-footer="{}">
        <b-button class="d-flex" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" :disabled="isLoadingEmployeePaidLeave" @click="submitItem()">
          <b-spinner small variant="light" class="mr-1" v-if="isLoadingEmployeePaidLeave" /> Simpan
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";
import {
  BButton,
  BSpinner,
  BFormFile
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";

import InputText from "@/components/InputText.vue";
import InputTextArea from "@/components/InputTextArea.vue";
import InputFile from "@/components/InputFile.vue";

import BranchListComponent from "@/components/Base/BranchListComponent.vue";
import EmployeeListComponent from "../Base/EmployeeListComponent.vue";

export default {
  components: {
    required,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    InputText,
    InputTextArea,
    InputFile,
    BFormFile,
    BranchListComponent,
    EmployeeListComponent
},
  
  directives: {
    Ripple,
  },
  
  props: {
    pageTitle: {
      type: String,
    },
    editId: {
      type: "",
    },
    loading: {
      type: Boolean,
    },
    formPayload: {
      type: "",
    },
    createItem: {
      type: Function,
    },
    updateItem: {
      type: Function,
    },
  },

  data() {
    return {
      isLoadingEmployeePaidLeave: false,
      formPayloadEmployeePaidLeave: {
        employeeId: "",
        endDate: "",
        isActive: "",
        paidLeaveId: "",
        paidLeaveLeft: "",
        startDate: ""
      },
      branchId: null,
      employeeId: null,
      filterValue: null,
      isLoadingEmployeeList: false
    };
  },

  watch: {
    loading(value) {
      this.isLoadingEmployeePaidLeave = value;
    },
    formPayload: {
      handler(value) {
        this.formPayloadEmployeePaidLeave = value;
        if (this.editId == null) {
          
        }
      },
      deep: true,
    },
    formPayloadEmployeePaidLeave: {
      handler(value) {
        this.$emit("formPayloadEmployeePaidLeave", value);
      },
      deep: true,
    },
    'branchId'(value) {
      this.isLoadingEmployeeList = false
      this.filterValue = null
      if (value !== null) {
        this.isLoadingEmployeeList = true
        this.filterValue = value
      }
    }
  },

  methods: {
    submitItem() {
      this.$refs.employeePaidLeaveValidation.validate().then((success) => {
        if (success) {
          if (this.editId == null) {
            this.createItem();
          } else {
            this.updateItem();
          }
        }
      });
    },
  },
};
</script>
